/* ============================================================
   TWO KXNGS COLLECTION + SEARCH FILTERS (Oct 2026)
   Ported from the drawer half of Empress assets/size-filter.js.
   Loaded by sections/main-collection and sections/main-search;
   pairs with snippets/facets.liquid and sections/facets-count.liquid.

   Prestige swaps the whole section on every filter change (its own
   facet:update), which can bring this script tag back with it, so
   everything here runs once and listens on document.

   1. Honest lengths: ticking a Length also ticks "In stock only".
      Shopify applies both filters to the same variant, so the results
      mean "in stock in that length" instead of "made in that length".
      Works in the phone drawer (applied when it closes) and the desktop
      sidebar (applied straight away).
   2. Phone drawer footer: the button shows the live result count
      ("Show 11 pieces") from sections/facets-count.liquid while picks
      change, and Clear all resets the drawer in place (results update
      when the drawer closes, like any other change).
   ============================================================ */
(function () {
  'use strict';

  if (window.tkCollectionFilters) return;
  window.tkCollectionFilters = true;

  /* The Length filter is the product option "Size" (filter.v.option.size); "Length" covers a future rename */
  var LENGTHS = ['filter.v.option.size', 'filter.v.option.length'];
  var STOCK = 'filter.v.availability';

  /* ---------- 1. A length always comes with In stock only ---------- */

  /* When a length switched In stock on, clearing the last length switches it off again; if the shopper set
     In stock themselves, it stays. Remembered per page in sessionStorage, as Prestige redraws the form each time. */
  var AUTO = 'tk:auto-stock:' + window.location.pathname;
  function setAuto(on) {
    try { if (on) sessionStorage.setItem(AUTO, '1'); else sessionStorage.removeItem(AUTO); } catch (e) {}
  }
  function isAuto() {
    try { return sessionStorage.getItem(AUTO) === '1'; } catch (e) { return false; }
  }
  function anyLength(form) {
    return LENGTHS.some(function (name) { return !!form.querySelector('input[name="' + name + '"]:checked'); });
  }

  /* Capture phase: runs before Prestige's facets-form reads the form, so the same request carries both */
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'checkbox' || !input.form) return;
    var stock = input.form.querySelector('input[name="' + STOCK + '"]');
    if (!stock) return;
    if (input === stock) { setAuto(false); return; }
    if (LENGTHS.indexOf(input.name) === -1) return;
    if (input.checked) {
      if (!stock.checked) { stock.checked = true; setAuto(true); }
    } else if (stock.checked && isAuto() && !anyLength(input.form)) {
      stock.checked = false;
      setAuto(false);
    }
  }, true);

  /* ---------- 2. Drawer footer: live count + Clear all ---------- */

  /* The same URL Prestige builds when the drawer closes */
  function formUrl(form) {
    var url = new URL(form.action, window.location.href);
    url.search = '';
    new FormData(form).forEach(function (value, key) { url.searchParams.append(key, value); });
    ['page', 'filter.v.price.gte', 'filter.v.price.lte'].forEach(function (key) {
      if (url.searchParams.get(key) === '') url.searchParams.delete(key);
    });
    return url;
  }

  function hasPicks(form) {
    if (form.querySelector('input[type="checkbox"]:checked')) return true;
    return Array.prototype.some.call(form.querySelectorAll('input[name^="filter.v.price"]'), function (input) {
      return input.value !== '';
    });
  }

  function showText(footer, count) {
    if (count === 0) return footer.dataset.noneText || 'No matches';
    if (count === 1) return footer.dataset.oneText || 'Show 1 piece';
    return (footer.dataset.showText || 'Show [count] pieces').replace('[count]', count);
  }

  var countTimer = null;
  var countAbort = null;

  function refreshDrawer(form) {
    var drawer = form.closest('facets-drawer');
    var footer = drawer && drawer.querySelector('[data-ff-footer]');
    if (!footer) return;

    var clear = footer.querySelector('[data-ff-clear]');
    if (clear) clear.hidden = !hasPicks(form);

    var label = footer.querySelector('[data-ff-show]');
    if (!label) return;

    clearTimeout(countTimer);
    footer.classList.add('is-counting');

    countTimer = setTimeout(function () {
      if (countAbort) countAbort.abort();
      countAbort = window.AbortController ? new AbortController() : null;

      var url = formUrl(form);
      url.searchParams.set('section_id', 'facets-count');
      /* Search: count pieces only, not blog posts and pages */
      if (/\/search\/?$/.test(url.pathname)) url.searchParams.set('type', 'product');

      fetch(url.toString(), { signal: countAbort ? countAbort.signal : undefined })
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var count = parseInt(String(html).replace(/<[^>]*>/g, '').trim(), 10);
          if (!isNaN(count)) label.textContent = showText(footer, count);
          footer.classList.remove('is-counting');
        })
        .catch(function (error) {
          if (!error || error.name !== 'AbortError') footer.classList.remove('is-counting');
        });
    }, 250);
  }

  document.addEventListener('change', function (event) {
    var form = event.target && event.target.closest && event.target.closest('facets-drawer facets-form form');
    if (form) refreshDrawer(form);
  });

  document.addEventListener('click', function (event) {
    var clear = event.target.closest && event.target.closest('[data-ff-clear]');
    if (!clear) return;

    var drawer = clear.closest('facets-drawer');
    var form = drawer && drawer.querySelector('facets-form form');
    if (!form) return;
    event.preventDefault();

    form.querySelectorAll('input[type="checkbox"]:checked').forEach(function (input) { input.checked = false; });
    form.querySelectorAll('input[name^="filter.v.price"]').forEach(function (input) { input.value = ''; });
    form.querySelectorAll('price-range input[type="range"]').forEach(function (range, index) {
      range.value = index === 0 ? range.min : range.max;
      range.parentElement.style.setProperty(index === 0 ? '--range-min' : '--range-max', index === 0 ? '0%' : '100%');
    });

    /* Marks Prestige's form as changed (so closing the drawer applies it) and refreshes the count */
    form.dispatchEvent(new Event('change', { bubbles: true }));
  });
})();
